import axios from "@/utils/axios"


/**
 * @deprecated 新接口不要使用这个函数了，应该使用 usePyRequest
 * @param {("GET"|"get"|"POST"|"post")} method
 * @param {string} url
 * @param {Record<string,any> | FormData} params
 * @returns {{method: string, url: string, params: *, noCancelable: boolean, isFormData: boolean, isPyRequest: boolean, isFPyRequest: boolean}}
 */
export function usePyConfig(method, url, params = {}) {
  return {
    method,
    url,
    params,
    noCancelable: false,
    isFormData: false,
    isPyRequest: true,
    isFPyRequest: false,
  };
}


/**
 * 使用 Python 接口
 * @param {("GET"|"get"|"POST"|"post")} method
 * @param {string} url
 * @param {Record<string,any> | FormData} params
 * @return {Promise<DefaultResponseType<any>>}
 */
export function usePyRequest(method, url, params = {}) {
  return axios(method, url, params, false, false, true, false);
}